'use client';

import { ClerkLoaded, SignIn, SignedOut, useSession } from '@clerk/nextjs';
import { Spacing } from '@ghosts-inc/design-system/constants';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@/components/Link';

export default function Content() {
  const { isLoaded } = useSession();

  return (
    <Stack alignItems="center">
      <SignIn
        appearance={{
          elements: {
            formFieldAction__password: {
              // hide the built-in password reset link
              display: 'none',
            },
          },
        }}
      />
      <ClerkLoaded>
        <SignedOut>
          <Stack direction="row" gap={Spacing.small} alignItems="center">
            <Typography variant="bodySmallHeavy" color="typographyDarkPrimary">
              Forgot your password?
            </Typography>
            <Link variant="link" href="/reset-password">
              Reset password
            </Link>
          </Stack>
        </SignedOut>
      </ClerkLoaded>
      {!isLoaded && <CircularProgress />}
    </Stack>
  );
}
